module.exports = __webpack_public_path__ + "static/logo-37a015d26a320c1e7431c5f80f2242cc.svg";